export default "__VITE_ASSET__zVrALbYu__"